import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import getTrialState from 'self-service-api/api/getTrialState';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
export const useMultiTrialTrackingProps = () => {
  const [activeTrials, setActiveTrials] = useState(null);
  const [expiredTrials, setExpiredTrials] = useState(null);
  const [isMultiTrial, setIsMultiTrial] = useState(null);
  useEffect(() => {
    getTrialState().then(trialState => {
      const oneYearAgoTimestamp = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime();
      const trialMap = Object.keys(trialState).reduce((acc, apiName) => {
        const trial = trialState[apiName];
        const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
        if (trial.hasTrialed) {
          if (trial.hasTrialed.lastTrialExpired >= oneYearAgoTimestamp) {
            acc.expiredTrials.push(upgradeProduct);
          }
        } else {
          acc.activeTrials.push(upgradeProduct);
        }
        return acc;
      }, {
        activeTrials: [],
        expiredTrials: []
      });
      setActiveTrials(trialMap.activeTrials);
      setExpiredTrials(trialMap.expiredTrials);
      setIsMultiTrial(trialMap.activeTrials.length > 1);
    }).catch(error => {
      setActiveTrials(null);
      setExpiredTrials(null);
      setIsMultiTrial(null);
      if (error && error.status !== 0) {
        Raven.captureException(error, {
          extra: {
            message: 'Failed to fetch trial state for multi-trial tracking props'
          }
        });
      }
    });
  }, []);
  const isLoadingTrackingProps = [isMultiTrial, activeTrials, expiredTrials].some(item => item === null);
  return {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  };
};